import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    error: false,
    stats: {},
    statsHost: {
        frontend: "PublicFrontend",
        backend: "Flow2",
        other: ""
    }
};

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.NLW_GET_STATS_SUCCESS:
            const { stats } = state;
            const data = { ...action.data[action.stats] };
            let rows = [ ...data.rows ];
            //console.log(action.data[action.stats]);
            rows = rows.filter(row => {
                //console.log(row);
                return row.host === action.host;
            });
            //console.log("----ROWS--------",rows);
            data.rows = [ ...rows ];
            
            //console.log(action.host,'data[action.stats].rows',data,action.stats,data[action.stats]);
            
            stats[action.host] = stats[action.host] ? { ...stats[action.host], ...{ [action.stats]: data } } : { [action.stats]: data };
            //console.log(stats);
            return updateObject(state, { stats: stats });
        default: 
            return state;
    }
}

export default reducer;
